import { render, staticRenderFns } from "./Home5.vue?vue&type=template&id=4a3cb008&scoped=true&"
import script from "./Home5.vue?vue&type=script&lang=js&"
export * from "./Home5.vue?vue&type=script&lang=js&"
import style0 from "./Home5.vue?vue&type=style&index=0&id=4a3cb008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3cb008",
  null
  
)

export default component.exports